import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useState } from "react";
import Chip from "@mui/material/Chip";
import classnames from "classnames";
import { Box } from "../../Box/index.js";
import { Tooltip } from "../../Tooltip/index.js";
import { Typography } from "../../Typography/index.js";
import { EllipsisText } from "../../EllipsisText/index.js";
import { Icon } from "../../Icon/index.js";
import { useStyles } from "./SelectedOptionsInput.styles.js";
const SelectedOptionsInput = (t0)=>{
    const $ = c(51);
    const { options, onDelete, limit: t1, renderTooltip, withTooltip, withBorder, maxWidth, disabledOptions, showAllOptionsButton: t2 } = t0;
    const limit = void 0 === t1 ? 15 : t1;
    const showAllOptionsButton = void 0 === t2 ? true : t2;
    let t3;
    if ($[0] !== maxWidth) {
        t3 = {
            maxWidth
        };
        $[0] = maxWidth;
        $[1] = t3;
    } else t3 = $[1];
    const { classes } = useStyles(t3);
    const [page, setPage] = useState(1);
    let T0;
    let T1;
    let shownOptions;
    let t10;
    let t11;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[2] !== classes || $[3] !== disabledOptions || $[4] !== limit || $[5] !== onDelete || $[6] !== options || $[7] !== page || $[8] !== renderTooltip || $[9] !== withBorder || $[10] !== withTooltip) {
        shownOptions = options.slice(0, limit * page);
        let t12;
        if ($[22] !== onDelete) {
            t12 = (option)=>{
                null == onDelete || onDelete(option);
            };
            $[22] = onDelete;
            $[23] = t12;
        } else t12 = $[23];
        const handleOptionDelete = t12;
        T1 = Box;
        t9 = "flex";
        t10 = "column";
        t11 = "8";
        T0 = Box;
        t4 = "flex";
        t5 = "wrap";
        t6 = "100%";
        t7 = "8";
        let t13;
        if ($[24] !== classes || $[25] !== disabledOptions || $[26] !== handleOptionDelete || $[27] !== renderTooltip || $[28] !== withBorder || $[29] !== withTooltip) {
            t13 = (option_0)=>/*#__PURE__*/ jsx(Box, {
                    maxWidth: "100%",
                    children: /*#__PURE__*/ jsx(Tooltip, {
                        disabled: !withTooltip,
                        title: renderTooltip ? renderTooltip(option_0) : option_0.label,
                        placement: "top",
                        children: /*#__PURE__*/ jsx(Chip, {
                            "data-testid": `selected-option-${option_0.value}`,
                            classes: {
                                root: classnames(classes.chipInput, withBorder && classes.withBorder),
                                deleteIcon: option_0.error ? classes.iconError : ""
                            },
                            label: /*#__PURE__*/ jsx(EllipsisText, {
                                rows: 1,
                                children: /*#__PURE__*/ jsx(Typography, {
                                    color: "inherit",
                                    variant: "body3",
                                    children: `${option_0.prefix ? `${option_0.prefix}, ` : ""}${option_0.label}`
                                })
                            }),
                            onDelete: ()=>handleOptionDelete(option_0),
                            deleteIcon: disabledOptions ? void 0 : /*#__PURE__*/ jsx(Icon, {
                                "data-testid": `selected-option-delete-${option_0.value}`,
                                name: "cancel",
                                size: "20"
                            }),
                            className: classnames(classes.chip, option_0.error && classes.chipError, disabledOptions && classes.chipDisabled)
                        })
                    })
                }, option_0.value);
            $[24] = classes;
            $[25] = disabledOptions;
            $[26] = handleOptionDelete;
            $[27] = renderTooltip;
            $[28] = withBorder;
            $[29] = withTooltip;
            $[30] = t13;
        } else t13 = $[30];
        t8 = shownOptions.map(t13);
        $[2] = classes;
        $[3] = disabledOptions;
        $[4] = limit;
        $[5] = onDelete;
        $[6] = options;
        $[7] = page;
        $[8] = renderTooltip;
        $[9] = withBorder;
        $[10] = withTooltip;
        $[11] = T0;
        $[12] = T1;
        $[13] = shownOptions;
        $[14] = t10;
        $[15] = t11;
        $[16] = t4;
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
        $[21] = t9;
    } else {
        T0 = $[11];
        T1 = $[12];
        shownOptions = $[13];
        t10 = $[14];
        t11 = $[15];
        t4 = $[16];
        t5 = $[17];
        t6 = $[18];
        t7 = $[19];
        t8 = $[20];
        t9 = $[21];
    }
    let t12;
    if ($[31] !== T0 || $[32] !== t4 || $[33] !== t5 || $[34] !== t6 || $[35] !== t7 || $[36] !== t8) {
        t12 = /*#__PURE__*/ jsx(T0, {
            display: t4,
            flexWrap: t5,
            maxWidth: t6,
            gap: t7,
            children: t8
        });
        $[31] = T0;
        $[32] = t4;
        $[33] = t5;
        $[34] = t6;
        $[35] = t7;
        $[36] = t8;
        $[37] = t12;
    } else t12 = $[37];
    let t13;
    if ($[38] !== classes || $[39] !== limit || $[40] !== options.length || $[41] !== showAllOptionsButton || $[42] !== shownOptions) {
        t13 = options.length > limit && /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            gap: "8",
            children: [
                options.length > shownOptions.length && /*#__PURE__*/ jsxs(Box, {
                    className: classes.button,
                    onClick: ()=>setPage(_temp),
                    children: [
                        /*#__PURE__*/ jsx(Typography, {
                            color: "inherit",
                            variant: "body3",
                            children: "Показать еще"
                        }),
                        /*#__PURE__*/ jsx(Icon, {
                            name: "more_horizontal",
                            size: "20"
                        })
                    ]
                }),
                showAllOptionsButton && options.length > shownOptions.length && /*#__PURE__*/ jsxs(Box, {
                    className: classes.button,
                    onClick: ()=>setPage(Math.ceil(options.length / limit)),
                    children: [
                        /*#__PURE__*/ jsxs(Typography, {
                            color: "inherit",
                            variant: "body3",
                            children: [
                                "Показать все ",
                                options.length
                            ]
                        }),
                        /*#__PURE__*/ jsx(Icon, {
                            name: "square_4_outline",
                            size: "20"
                        })
                    ]
                }),
                options.length <= shownOptions.length && options.length > limit && /*#__PURE__*/ jsx(Box, {
                    className: classes.button,
                    onClick: ()=>setPage(1),
                    children: /*#__PURE__*/ jsx(Typography, {
                        color: "inherit",
                        variant: "body3",
                        children: "Скрыть"
                    })
                })
            ]
        });
        $[38] = classes;
        $[39] = limit;
        $[40] = options.length;
        $[41] = showAllOptionsButton;
        $[42] = shownOptions;
        $[43] = t13;
    } else t13 = $[43];
    let t14;
    if ($[44] !== T1 || $[45] !== t10 || $[46] !== t11 || $[47] !== t12 || $[48] !== t13 || $[49] !== t9) {
        t14 = /*#__PURE__*/ jsxs(T1, {
            display: t9,
            flexDirection: t10,
            gap: t11,
            children: [
                t12,
                t13
            ]
        });
        $[44] = T1;
        $[45] = t10;
        $[46] = t11;
        $[47] = t12;
        $[48] = t13;
        $[49] = t9;
        $[50] = t14;
    } else t14 = $[50];
    return t14;
};
function _temp(currentPage) {
    return currentPage + 1;
}
export { SelectedOptionsInput };
